const SOURCE_SELECT = "/source-select";
const EXCEL_IMPORT = "/excel-import";
const LANDING = "/";
const SIGN_IN = "/login";
const DASHBOARD = "/dashboard";
const SETTINGS = "/settings";
const PROJECTS = "/projects";
const BVATOOL = "/bvatool";
const REPORTS = "/reports";
const ADMIN_STRIPE = "/admin-stripe";
const ADMIN_SETTINGS = "/admin-settings";
const STRIPE_SUBSCRIPTION = "/subscription-settings";

export {
  SOURCE_SELECT,
  EXCEL_IMPORT,
  LANDING,
  SIGN_IN,
  DASHBOARD,
  SETTINGS,
  PROJECTS,
  BVATOOL,
  REPORTS,
  ADMIN_STRIPE,
  ADMIN_SETTINGS,
  STRIPE_SUBSCRIPTION,
};
